/**
 * Public Club 4X4 site URLs used from the portal (e.g. same as the nav “Contact us” item).
 * @module claims/contactLinks
 */

export const CLUB4X4_CONTACT_US_HREF = 'https://www.club4x4.com.au/contact-us/' as const

/** Policy and general insurance FAQs on the Club 4X4 website. */
export const CLUB4X4_FAQS_HREF = 'https://www.club4x4.com.au/faqs/' as const

/** Club 4X4 online self-service hub (portal entry, sign-up guidance, FAQs). */
export const CLUB4X4_SELF_SERVICE_HREF = 'https://www.club4x4.com.au/self-service/' as const

/** Claims information on the Club 4X4 website. */
export const CLUB4X4_CLAIMS_HREF = 'https://www.club4x4.com.au/claims' as const

/** Help and support on the Club 4X4 website. */
export const CLUB4X4_CUSTOMER_SUPPORT_HREF = 'https://www.club4x4.com.au/customer-support/' as const

/** PDS, FSG, TMD and other policy documents on the Club 4X4 website. */
export const CLUB4X4_POLICY_DOCUMENTS_HREF =
  'https://www.club4x4.com.au/product-disclosure-statement/' as const

/** Club 4X4 marketing site home. */
export const CLUB4X4_WEBSITE_HREF = 'https://www.club4x4.com.au/' as const

/** Partner discounts, vouchers and policy benefits on the Club 4X4 website. */
export const CLUB4X4_BENEFITS_HREF = 'https://www.club4x4.com.au/benefits/' as const

/** Customer portal registration and login. */
export const CLUB4X4_PORTAL_HREF = 'https://portal.club4x4.com.au' as const

/** In-portal FAQ page route. */
export const PORTAL_FAQ_PATH = '/help/faq' as const

/** Club 4X4 customer service phone (display and `tel:` dial string). */
export const CLUB4X4_PHONE_DISPLAY = '1300 296 296' as const

/** `tel:` URI for the Club 4X4 customer service phone number. */
export const CLUB4X4_PHONE_TEL = 'tel:1300296296' as const

/** Standard Club 4X4 phone support hours. */
export const CLUB4X4_BUSINESS_HOURS = '8.30 am to 5.30 pm AEST' as const
